import { ellipse } from "@thi.ng/geom";

export const mouth = (centerX: number, centerY: number, radius: number, radiusX = radius) => {
  return ellipse([centerX, centerY], [radiusX, radius], { fill: "black" });
};
